import { addDays, differenceInDays, eachDayOfInterval, eachMonthOfInterval, endOfMonth, endOfWeek, format, getDay, getMonth, getYear, isSaturday, isSunday, startOfMonth, startOfWeek } from 'date-fns';
import { de } from 'date-fns/locale';
export const getWeekdays = ({
  firstDayOfWeek = 1
} = {}) => {
  const now = new Date();
  const weekdays = eachDayOfInterval({
    start: addDays(startOfWeek(now), firstDayOfWeek),
    end: addDays(endOfWeek(now), firstDayOfWeek)
  });
  return weekdays.map(date => {
    return {
      label: format(date, 'iiiiii', {
        locale: de
      }),
      weekend: isSaturday(date) || isSunday(date)
    };
  });
};
export const getCalendarMonths = ({
  startDate,
  endDate
}) => {
  return eachMonthOfInterval({
    start: startDate,
    end: endDate
  }).map(firstDayOfMonth => {
    const label = format(firstDayOfMonth, 'MMMM yyyy', {
      locale: de
    });
    const year = getYear(firstDayOfMonth);
    const month = getMonth(firstDayOfMonth);
    const days = getCalendarDays({
      year,
      month
    });
    return {
      label,
      year,
      month,
      days
    };
  });
};
const getCalendarDays = ({
  year,
  month,
  firstDayOfWeek = 1
}) => {
  const date = new Date(year, month);
  const monthStart = startOfMonth(date);
  const monthStartDay = getDay(monthStart);
  const monthEnd = endOfMonth(date);
  const previousMonthDays = new Array(monthStartDay >= firstDayOfWeek ? monthStartDay - firstDayOfWeek : 6 - firstDayOfWeek + monthStartDay + 1).fill(undefined);
  const days = eachDayOfInterval({
    start: monthStart,
    end: monthEnd
  }).map(date => ({
    date,
    label: format(date, 'd', {
      locale: de
    })
  }));
  return [...previousMonthDays, ...days];
};
export const getInitialView = ({
  startDate,
  months,
  nextVisibleMonth
}) => {
  if (!startDate) {
    return 0;
  }
  const startDateMonth = getMonth(startDate);
  const startDateYear = getYear(startDate);
  const initialView = Math.floor(months.findIndex(({
    year,
    month
  }) => year === startDateYear && month === startDateMonth) / nextVisibleMonth);
  return initialView;
};
export const mapDateRange = ({
  pending,
  start,
  end
}) => ({
  pending,
  start,
  end,
  days: start && end ? differenceInDays(end, start) + 1 : 0
});